import { render } from "./소화기내시경센터.vue?vue&type=template&id=d0353876"
import script from "./소화기내시경센터.vue?vue&type=script&lang=js"
export * from "./소화기내시경센터.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__